export const historyQuickAdjustOperate = 'quick-adjust-operate';
export const historyQuickResizeOperate = 'quick-resize-operate';
